import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { bulkDeleteConsignmentItems } from '../api/bulkDeleteConsignmentItems'

function useBulkDeleteConsignmentItems(consignmentId: number, houseConsignmentId: number) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: bulkDeleteConsignmentItems,
    onSuccess: async () => {
      await queryClient.invalidateQueries(QueryKeys.houseConsignment.all(consignmentId))
      await queryClient.invalidateQueries(QueryKeys.consignmentItem.all({ consignmentId, houseConsignmentId }))
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
  })

  const { mutateAsync, isLoading } = mutation

  const bulkDelete = (ids: number[]) => mutateAsync(ids)

  return {
    bulkDelete,
    isBulkDeleting: isLoading,
  }
}

export default useBulkDeleteConsignmentItems
